import React, { useState } from "react";
import Papa from "papaparse";

export default function CSVUploadComponent({
  bookId,
  target,
  updateTriggerProps,
  handleSaveButton,
  handleApplyChanges,
}) {
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      setUploadStatus("Processing...");

      parseCSV(uploadedFile);
    }
  };
  function parseCSV(file) {
    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: function (results) {
        if (results.data.length < 4) {
          console.error("CSV file does not contain enough data.");
          setUploadStatus(
            "Upload failed: CSV file does not contain enough data."
          );

          return;
        }
        console.log(results.data);
        // Extract quiz metadata
        const quizMetadata = {
          title: results.data[1][0],
          attempts: parseInt(results.data[1][1]) || 1,
          quizType: results.data[1][2],
          isOpenBook: results.data[1][3].toUpperCase() === "TRUE",
        };

        // Extract headers for questions from the third row
        const questionHeaders = results.data[2];

        // Process the question data
        const questionData = results.data.slice(3).map((row) => {
          let questionObj = {};
          questionHeaders.forEach((header, index) => {
            questionObj[header] = row[index];
          });
          return questionObj;
        });

        // Format the quiz data
        const formattedQuizData = formatQuizData(questionData, quizMetadata);
        console.log(formattedQuizData);
        handleApplyChanges({
          csvData: {
            ...target,
            title: { en: formattedQuizData.title },
            quizType: formattedQuizData.quizType,
            // titleAudio: newTitleAudioClip,
            isQuiz: true,

            quizDetails: formattedQuizData,

            // fill: previewColor,
          },
        });
        setUploadStatus("Upload successful!");
      },
    });
  }

  function formatQuizData(questionData, quizMetadata) {
    const quiz = {
      title: quizMetadata.title,
      attempts: quizMetadata.attempts,
      isOpenBook: quizMetadata.isOpenBook,
      questions: [],
      externalBookId: bookId,
      quizType: quizMetadata.quizType,
    };

    questionData.forEach((row) => {
      const question = {
        type: row.questionType,
        contents: {
          q: { en: row.questionText },
          a: [],
          feedback: {
            en: {
              pos: row.posFeedback,
              neg: row.negFeedback,
            },
          },
        },
      };

      // Dynamically add answers
      let optionIndex = 1;
      while (
        row[`option${optionIndex}`] !== undefined &&
        row[`option${optionIndex}`] !== ""
      ) {
        question.contents.a.push({
          text: { en: row[`option${optionIndex}`] },
          correct: row.correctAnswers
            .split(",")
            .map(Number)
            .includes(optionIndex),
        });
        optionIndex++;
      }

      quiz.questions.push(question);
    });

    return quiz;
  }

  return (
    <div>
      <input type="file" accept=".csv" onChange={handleFileChange} />{" "}
      {uploadStatus && <p>{uploadStatus}</p>}
    </div>
  );
}
